import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconMathflat = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 35,
	height: 35,
	fill: "none",
	viewBox: "0 0 35 35",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			x: .5,
			y: .5,
			fill: "#fff",
			stroke: "#F5F5F5",
			rx: 3.5
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#00D8FF",
				d: "M23.48 7.143c-2.357.487-9.206 1.86-10.496 2.127-.133.044-.222.133-.222.266v10.723S21.479 10.2 23.747 7.586c.134-.177-.044-.487-.267-.443z"
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#197FDB",
				d: "M12.85 21.233l6.672-7.71v14.18c0 .265-.311.354-.49.177-1.423-1.462-5.514-5.76-6.182-6.47-.088-.044-.088-.132 0-.177z"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0H12.143V22.143H0z",
				transform: "translate(12.143 6.429)"
			})
		}) })
	]
});
export default SvgIconMathflat;
